import React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

const OnHold = ({ ...props }) => {
  return (
    <Svg
      width={29}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#a)">
        <Path
          d="M19.588 1.363H9.412A3.824 3.824 0 0 0 6.1 3.276l-5.088 8.812a3.825 3.825 0 0 0 0 3.824L6.1 24.724a3.824 3.824 0 0 0 3.312 1.913h10.176a3.824 3.824 0 0 0 3.312-1.913l5.088-8.812a3.825 3.825 0 0 0 0-3.824L22.9 3.276a3.825 3.825 0 0 0-3.312-1.913Z"
          fill="#D1D9E9"
        />
        <Path
          d="M9.412 24.383c-.56 0-1.08-.3-1.36-.785l-5.088-8.812a1.575 1.575 0 0 1 0-1.572l5.088-8.812c.28-.484.8-.785 1.36-.785h10.176c.56 0 1.08.3 1.36.785l5.088 8.813c.28.484.28 1.086 0 1.57l-5.088 8.813c-.28.484-.8.785-1.36.785H9.412Z"
          fill="#596379"
        />
        <Path
          d="M20.568 14.748c-.314.566-.314 1.833-.314 1.848 0 0-.024 4.906-3.568 4.906h-3.189c-2.615 0-4.092-2.677-4.092-4.98v-5.114a1.07 1.07 0 0 1 2.142 0V9.239a1.07 1.07 0 0 1 2.141 0V7.57a1.07 1.07 0 1 1 2.142 0v1.349a1.07 1.07 0 1 1 2.142 0v5.745a5.391 5.391 0 0 1 .458-1.1 1.222 1.222 0 0 1 1.66-.478l.003.001c.59.328.803 1.072.475 1.662Z"
          fill="#fff"
        />
        <Path
          d="M11.947 14.809a.4.4 0 0 1-.4-.4v-5.17a1.07 1.07 0 0 1 1.471-.993 1.07 1.07 0 0 0-.67.993v5.17a.4.4 0 0 1-.4.4Z"
          fill="#F1B986"
        />
        <Path
          d="M14.089 14.732a.4.4 0 0 1-.4-.4V7.568a1.07 1.07 0 0 1 1.47-.993 1.07 1.07 0 0 0-.67.993v6.762a.4.4 0 0 1-.4.4ZM16.23 14.26a.4.4 0 0 1-.4-.4V8.917a1.07 1.07 0 0 1 1.472-.993 1.07 1.07 0 0 0-.67.993v4.941a.4.4 0 0 1-.401.4ZM11.947 14.809a.4.4 0 0 1-.4-.4v-5.17a1.07 1.07 0 0 1 1.471-.993 1.07 1.07 0 0 0-.67.993v5.17a.4.4 0 0 1-.4.4Z"
          fill="#D1D9E9"
        />
        <Path
          d="M14.298 21.502h-.8c-2.616 0-4.093-2.677-4.093-4.98v-5.114a1.07 1.07 0 0 1 1.471-.993 1.07 1.07 0 0 0-.67.993v5.114c0 2.303 1.477 4.98 4.092 4.98ZM18.43 13.562c-.155.28-.283.57-.384.866-.024.09-.05.168-.074.235a3.78 3.78 0 0 0-.205 1.512 2.82 2.82 0 0 0-2.796 2.443.369.369 0 0 0 .332.412.372.372 0 0 0 .383-.24c.876-2.314 3.081-1.956 3.081-1.956-.562-1.658.739-4.026 1.323-3.749a1.222 1.222 0 0 0-1.66.477Z"
          fill="#D1D9E9"
        />
      </G>
      <Defs>
        <ClipPath id="a">
          <Path fill="#fff" transform="translate(.5)" d="M0 0h28v28H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default OnHold
